// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#interviewRoom .fcr-btn {\n  line-height: normal;\n}\n#interviewRoom .layout-aside {\n  max-width: 18rem;\n  min-width: 0rem !important;\n}\n#interviewRoom .edu-room {\n  height: calc(100vh - 82px) !important;\n}\n#interviewRoom .chat-texting .btn {\n  line-height: 0.5rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
